import { useContext } from 'react';

import { TimeseriesThresholdContext } from '../context/TimeseriesThreshold.context.js';
import { TimeseriesChartThresholdsConfig } from '../types/timeseries-config.js';

export const useThresholdConfig = (): TimeseriesChartThresholdsConfig =>
  useContext(TimeseriesThresholdContext);
